import { render, staticRenderFns } from "./system_mechanism_details.vue?vue&type=template&id=25559d5c&"
import script from "./system_mechanism_details.vue?vue&type=script&lang=js&"
export * from "./system_mechanism_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports